import { useEffect, useState } from "react";
import { API_URLS } from "../../apiUrl";
import axiosInstance from "../../components/axiosInstance";

function PurposeOfPropertyDropdown(propertyTypeId: any, propertyDescriptioTypeId: any, useOfProperty: any) {
  const [purposeOfProperty, setPurposeOfProperty] = useState<any>([]);
  const [loadingPurposeOfProperty, setLoadingPurposeOfProperty] = useState(false);
  const [isDropdownOpenPurposeOfProperty, setIsDropdownOpenPurposeOfProperty] = useState(false);

  const fetchPurposeOfProperty = async () => {
    if (loadingPurposeOfProperty) return;

    setLoadingPurposeOfProperty(true);

    try {
      const response = await axiosInstance.post(`${API_URLS.TypeDescriptionWisePurposeOfProperty}`,
        {
          property_type_id: propertyTypeId,
          property_description_id: propertyDescriptioTypeId,
          use_of_property_id: useOfProperty
        }
      );

      if (response.data.data.rows) {
        setPurposeOfProperty(response.data.data.rows);
      }
    } catch (error) {
      console.error("Error fetching property descriptions", error);
    } finally {
      setLoadingPurposeOfProperty(false);
    }
  };

  useEffect(() => {
    if (propertyTypeId && propertyDescriptioTypeId && useOfProperty) {
      fetchPurposeOfProperty();
    }
  }, [propertyTypeId, propertyDescriptioTypeId, useOfProperty]);

  return [
    setIsDropdownOpenPurposeOfProperty,
    isDropdownOpenPurposeOfProperty,
    fetchPurposeOfProperty,
    purposeOfProperty,
    loadingPurposeOfProperty
  ];
}

export default PurposeOfPropertyDropdown;